import React from 'react';
import './BurgerMenu.css';

const BurgerMenu = ({ isOpen, onClose, children }) => {
    return (
        <>
            <button 
                className={`burger-button ${isOpen ? 'open' : ''}`}
                onClick={() => onClose(!isOpen)}
                aria-label="Toggle menu"
            >
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div className={`burger-menu ${isOpen ? 'open' : ''}`}>
                <button className="close-button" onClick={() => onClose(false)}>
                    ×
                </button>
                {children}
            </div>
        </>
    );
};

export default BurgerMenu; 